import React, { useState, useEffect, useContext } from "react";
import SideMenu from "./sideMenu";
import DashboardWidgets from "./dashboard/dashboardwidgets";
import { Route, Switch, Redirect } from "react-router-dom";
import Header from "./header";
import Spinner from "../../common/spinner";
import { UserContext } from '../../contexts/UserContext';
import ViolationForPlazaReviewListing from "../Contents/PendingForReviewToll/violationforplazareviewlisting";
import AssignedToMeListing from "../Contents/AssignedToMe/assignedtomelisting";
import CompleteViolationsListing from "./CompletedViolation/CompleteViolationslisting";
import SearchListingPage from "../Contents/SearchListingPage/searchlistingpage";
import AuthGuard from "../../common/AuthGuard";
import ViolationAnaltics from '../Contents/ViolationsAnalytics/violationAnaltics'
import RaisedViolationScreen from "./RaisedNewViolation/RaisedViolationScreen";
import ConcessionaireDashboard from "../ConcessionaireDashboard/ConcessionaireDashboard";
import RaisedCreditAdjustmentsScreen from "./CreditAdjustment/RaisedCreditAdjustmentsScreen";
import ETCReportScreen from "./ETCReport/ETCReportScreen";


export default function Dashboard(props) {
  const userDetail = useContext(UserContext);
  const [globalTotalViolation, setGlobalTotalViolation] = useState(0);
  const [globalactiveviolation, setGlobalActiveViolation] = useState(0);
  const [globalassignedtome, setGlobalAssignedToMe] = useState(0);
  const [globalviolationdata, setGlobalViolationData] = useState([]);
  const [isCAReport, setIsCAReport] = useState(false);
  const hasConcess = userDetail?.roles?.includes("ROLE_CONCESSIONAIRE"); //putting in useeffect causes delay

  useEffect(() => {
        if(userDetail?.roles!==null && userDetail?.roles.length!==0){
      const role = userDetail?.roles;
      setIsCAReport(role?.includes("ROLE_CA_REPORT"));
    }
    },[userDetail])
  return (
    <>
      <Spinner />
      <SideMenu {...props} />
      <div id="content">
        <div className="container-fluid">
          <Header />
          <Switch>
            <Redirect
              exact
              from="/dashboard"
              to={
                (hasConcess)
                  ? "/dashboard/ConcessionaireDashboard"
                  : "/dashboard/dashboardwidgets"
              }
            />
            <Route
              path="/dashboard/ConcessionaireDashboard"
              render={(props) => (
                <AuthGuard
                  globalTotalViolation={globalTotalViolation}
                  Comp={ConcessionaireDashboard}
                  // showCondashboard={showCondashboard}
                  {...props}
                />
              )}
            />
            <Route
              path="/dashboard/dashboardwidgets"
              render={(props) => (
                <AuthGuard
                  {...props}
                  setGlobalAssignedToMe={setGlobalAssignedToMe}
                  setGlobalTotalViolation={setGlobalTotalViolation}
                  setGlobalActiveViolation={setGlobalActiveViolation}
                  setGlobalViolationData={setGlobalViolationData}
                  globalassignedtome={globalassignedtome}
                  Comp={DashboardWidgets}
                />
              )}
            />
            <Route path="/dashboard/completedviolationlisting/completed">
              Completed violations not Found
            </Route>
            <Route
              path="/dashboard/violationforplazareviewlisting"
              render={(props) => (
                <AuthGuard
                  {...props}
                  globalviolationdata={globalviolationdata}
                  globalactiveviolation={globalactiveviolation}
                  setGlobalActiveViolation={setGlobalActiveViolation}
                  Comp={ViolationForPlazaReviewListing}
                />
              )}
            />
            <Route
              path="/dashboard/assignedtomelisting"
              render={(props) => (
                <AuthGuard
                  Comp={AssignedToMeListing}
                  setGlobalAssignedToMe={setGlobalAssignedToMe}
                  globalassignedtome={globalassignedtome}
                  {...props}
                />
              )}
            />
            <Route
              path="/dashboard/CompleteViolations"
              render={(props) => (
                <AuthGuard
                  globalTotalViolation={globalTotalViolation}
                  Comp={CompleteViolationsListing}
                  {...props}
                />
              )}
            />
            <Route
              path="/dashboard/violations"
              render={(props) => (
                <AuthGuard {...props} Comp={SearchListingPage} />
              )}
            />
             <Route path="/dashboard/violationAnaltics" render={(props) =>
              <AuthGuard
                Comp={ViolationAnaltics}
                {...props}
              />} />
            {/* <Route path="/dashboard/raisedNewViolation" render={(props) =>
              <AuthGuard
                Comp={RaisedNewViolation}
                {...props}
            />} /> */}
            <Route path="/dashboard/RaisedNewViolation" render={(props) =>
              <AuthGuard
                Comp={RaisedViolationScreen}
                {...props}
              />} />
            <Route path="/dashboard/ETCTATReport"
              render={(props) => (
                <AuthGuard {...props} Comp={ETCReportScreen} />
              )}
            />
            {isCAReport ? (
              <>
                <Route
                  path="/dashboard/RaisedCreditAdjustmentsScreen"
                  render={(props) => (
                    <AuthGuard
                      Comp={RaisedCreditAdjustmentsScreen}
                      {...props}
                    />
                  )}
                />
            </>): null }

          </Switch>
        </div>
      </div>
    </>
  );
}



